import { reminderService } from "client-app-core";
import * as t from "./actionTypes";

const reminderAdded = (payload) => {
	return {
		type: t.REMINDER_ADDED,
		payload
	};
};

const reminderChanged = (payload) => {
	return {
		type: t.REMINDER_CHANGED,
		payload
	};
};

const reminderRemoved = (payload) => {
	return {
		type: t.REMINDER_REMOVED,
		payload
	};
};

export const startReminderStream = () => {
	return (dispatch) => {
		reminderService.streamReminders((err, change) => {
			if (err) {
				console.log("Reminder error received", err);
			} else {
				switch (change.type) {
					case "initial":
					case "add":
						dispatch(reminderAdded(change.new_val));
						break;
					case "change":
						dispatch(reminderChanged(change.new_val));
						break;
					case "remove":
						dispatch(reminderRemoved(change.old_val));
						break;
					default:
						break;
				}
			}
		});
	};
};

export const createReminder = (reminder) => {
	return (dispatch) => {
		reminderService.createReminder(reminder, (err, response) => {
			if (err) {
				console.error("Error creating reminder:", err);
			}
		});
	};
};

export const updateReminder = (reminderId, reminder) => {
	return (dispatch) => {
		reminderService.updateReminder(reminderId, reminder, (err, response) => {
			if (err) {
				console.error("Error updating reminder:", err);
			}
		});
	};
};

export const deleteReminder = (reminderId) => {
	return (dispatch) => {
		reminderService.deleteReminder(reminderId, (err, response) => {
			if (err) {
				console.error("Error deleting reminder:", err);
			}
		});
	};
};

export const deleteReminders = (reminderIds) => {
	return (dispatch) => {
		reminderService.deleteRemindersBulk(reminderIds, (err, response) => {
			if (err) {
				console.error("Error deleting reminders:", err);
			}
		});
	};
};
